export const exportCSV = (
  fileName = "fileName",
  title = "title",
  ...content
) => {
  // 產生 csv Blob
  const csvContent = () => {
    let mergeContent = `${[...title].join(",")}\n`; // csv 標題
    while (content[0].length > 0) {
      //csv 內容
      const tempArr = content
        .map((item) => item.shift())
        .slice(0, title.length);
      mergeContent += `${tempArr.join(",")}\n`;
    }
    return URL.createObjectURL(
      new Blob([`\uFEFF${mergeContent}`], { type: "text/csv;charset=utf-8;" })
    );
  };

  // 產生 csv 連結
  let link = document.createElement("a");
  link = Object.assign(link, {
    href: csvContent(),
    download: `${fileName}.csv`,
  });
  return link.click();
};
